import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './delete-amenity-modal.module.scss';
import { trackEvent } from '../../../../../shared/services/utils/tracking/tracking.service';
import Modal from '../../../../../shared/components/core-ui/modal/modal.component';
import Button, {
  ButtonSize,
  ButtonType
} from '../../../../../shared/components/core-ui/button/button.component';
import useWindowResizer from '../../../../../shared/hooks/window-resizer/window-resizer.hook';
import { AmenityUiModel } from '../../../../../shared/ui-models/amenity.ui-model';

export interface DeleteAmenityModalProps {
  data: {
    amenity?: AmenityUiModel;
  };
  config: {
    showModal: boolean;
  };
  eventHandlers: {
    cancelHandler: () => void;
    deleteAmenityHandler: (amenity: AmenityUiModel) => void;
  };
}

/**
 * functional component DeleteAmenityModal
 * @param {DeleteAmenityModalProps}
 */
export const DeleteAmenityModal: React.FC<DeleteAmenityModalProps> = ({
  data,
  config,
  eventHandlers
}) => {
  const { t } = useTranslation();
  const isMobileView = useWindowResizer();

  const handleDeleteAmenitySubmit = () => {
    if (data && data.amenity) {
      eventHandlers.deleteAmenityHandler(data.amenity);
    }
  };

  return (
    <Modal
      config={{ showModal: config.showModal, fullScreen: false, showClose: true }}
      eventHandlers={{
        closeModalHandler: () => {
          eventHandlers.cancelHandler();
        }
      }}
    >
      <div className={styles['add-amenity-modal']}>
        <div className={styles['add-amenity-modal__title']}>
          {t('AMENITY_MODULE.LIST_CONTAINER.DELETE_AMENITY_MODAL.TITLE')}
        </div>
        <div className={styles['add-amenity-modal__description']}>
          {`${t('AMENITY_MODULE.LIST_CONTAINER.DELETE_AMENITY_MODAL.DESCRIPTION')} ${
            data.amenity?.name
          }`}
        </div>
      </div>
      <div className={styles['add-amenity-modal--actions']}>
        <Button
          onClick={() => {
            eventHandlers.cancelHandler();
            trackEvent('record_edit_cancelled', { entity: 'amenity', method: 'cancel' });
          }}
          tracking={{ event: 'record_edit_cancelled', entity: 'amenity', method: 'cancel' }}
          size={isMobileView ? ButtonSize.full : ButtonSize.medium}
          type={ButtonType.primaryInverted}
        >
          {t('AMENITY_MODULE.LIST_CONTAINER.DELETE_AMENITY_MODAL.CANCEL_BUTTON')}
        </Button>
        <Button
          onClick={handleDeleteAmenitySubmit}
          tracking={{
            event: 'record_saved',
            entity: 'amenity',
            action: 'update',
            outcome: 'success'
          }}
          type={ButtonType.danger}
          size={isMobileView ? ButtonSize.full : ButtonSize.medium}
        >
          {t('AMENITY_MODULE.LIST_CONTAINER.DELETE_AMENITY_MODAL.SUBMIT_BUTTON')}
        </Button>
      </div>
    </Modal>
  );
};
